import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { ledgerRows, settleFlow } from '@/mocks/jiuchou-business';

export default function Ledger() {
  const [showSettle, setShowSettle] = useState(false);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="透明账本"
            title="每一笔价值，都有记录"
            subtitle="九畴云铺以动态账本记录商品、交易、用户、推荐、服务、供应链、平台、清分与对账的每一环数据。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {ledgerRows.map((r) => (
              <button
                key={r.field}
                onClick={() => r.field === '清分' && setShowSettle((v) => !v)}
                className={`flex items-center justify-between p-4 rounded-lg border text-left cursor-pointer transition-colors ${
                  r.field === '清分'
                    ? 'border-primary-400 bg-primary-50 hover:bg-primary-100'
                    : 'border-background-200 bg-background-100 cursor-default'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="font-medium text-foreground-950">{r.field}</span>
                </div>
                <span className="text-sm text-foreground-500">{r.data}</span>
                {r.field === '清分' && (
                  <i className="ri-arrow-down-s-line text-primary-600"></i>
                )}
              </button>
            ))}
          </div>
        </Reveal>

        {showSettle && (
          <Reveal>
            <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-2 font-heading font-bold text-foreground-950 mb-6">
                <i className="ri-flow-chart text-primary-600 text-xl"></i>
                点击「清分」后：从订单到最终结果
              </div>
              <FlowExplorer steps={settleFlow} direction="horizontal" accent="primary" />
              <p className="mt-6 text-sm text-foreground-500 leading-relaxed">
                注：项目文件将「清分差错率 0」等作为产品服务包的可量化效果指标，作为项目目标/验收指标展示，不包装为已实现的事实。
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}